const suppliers = {
  toast: {
    error: {
      badResponse: '[Fleet] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fleet] נוצר בהצלחה',
      },
      edit: {},
    },
  },
  create: {
    successToast: {
      message: 'הצלחה! הצי נוצר בהצלחה!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן היה ליצור את הצי',
    },
  },

  edit: {
    successToast: {
      message: 'הצלחה! הצי עודכן בהצלחה!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן היה לעדכן את הצי',
    },
  },

  deleteModal: {
    header: 'מחיקת ציים',
    body: 'אתה עומד למחוק {{num}} ציים.',
  },

  deleteToast: 'לא ניתן למחוק ציים',

  forms: {
    information: {
      rank: {
        header: 'דירוג וניקוד של הצי',
      },
      supplierKpis: {
        header: 'מדדי ביצועים של הצי',
      },
    },
  },
  delete: {
    confirmation: {
      header: 'אישור מחיקת הצי',
      body: 'הציים נמחקו בהצלחה',
    },
  },
};

export default suppliers;
